module.exports = __webpack_public_path__ + "static/media/image.8df9e5fb.jpeg";